<template>
  <div class="sp_deviceDetails">
    <heade-title :title="title"
                 :showClose="showClose"
                 @closePage='closePage'></heade-title>
    <div class="tab-content">

      <div v-for="val in tabsList"
           class="tab"
           :key="val.id"
           @click="handleTabs(val.id)"
           :class="{is_active:activeIndex == val.id}">
        <span>{{val.name}}</span>
      </div>

    </div>
    <div class="sp_content">
      <div class="sp_information"
           v-if="activeIndex == 1">
        <el-row>
          <div class="sp_infoTitle"><span></span>
            <p>Device Basic Information</p>
          </div>
          <el-col :span="4">
            <p class="sp_infoCount"><label>Serial Number：</label><span>{{deviceInfo.sn}}</span></p>
          </el-col>
          <el-col :span="4">
            <p class="sp_infoCount"><label>Gateway ID：</label><span>{{deviceInfo.deviceId}}</span></p>
          </el-col>
          <!-- <el-col :span="8">
            <p class="sp_infoCount"><label>Order No：</label><span>{{deviceInfo.orderId}}</span></p>
          </el-col> -->
          <el-col :span="4">
            <p class="sp_infoCount"><label>Model：</label><span>{{deviceInfo.model}}</span></p>
          </el-col>
          <el-col :span="4">
            <p class="sp_infoCount"><label>Product：</label><span>{{deviceInfo.model.indexOf("NSF") == 0 ? "NSF" : deviceInfo.productType}}</span></p>
          </el-col>
          <!-- <el-col :span="8">
            <p class="sp_infoCount"><label>Order Date：</label><span>{{deviceInfo.orderTime?moment(deviceInfo.orderTime).format("YYYY-MM-DD"):'--'}}</span></p>
          </el-col> -->
        </el-row>

        <el-row>
          <div class="sp_infoTitle title-info"><span></span>
            <p>Device Status Information</p>
          </div>
          <el-col :span="4">
            <p class="sp_infoCount"><label>Status：</label><span>{{deviceStatus[deviceInfo.licStatus]}}</span></p>
          </el-col>
          <el-col :span="4">
            <p class="sp_infoCount"><label>Added Date：</label><span>{{deviceInfo.createTime?moment(deviceInfo.createTime).format("YYYY-MM-DD"):'--'}}</span></p>
          </el-col>
          <el-col :span="4">
            <p class="sp_infoCount"><label>Update Date：</label><span>{{deviceInfo.updateTime?moment(deviceInfo.updateTime).format("YYYY-MM-DD"):'--'}}</span></p>
          </el-col>
          <el-col :span="4"
                  v-show="deviceInfo.licStatus!== 0">
            <p class="sp_infoCount"><label>License Createtime：</label><span>{{deviceInfo.licenseCreateTime?moment(deviceInfo.licenseCreateTime).format("YYYY-MM-DD"):'--'}}</span></p>
          </el-col>
          <el-col :span="4"
                  v-show="deviceInfo.licStatus!== 0">
            <p class="sp_infoCount"><label>License Updatetime：</label><span>{{deviceInfo.licenseUpdateTime?moment(deviceInfo.licenseUpdateTime).format("YYYY-MM-DD"):'--'}}</span></p>
          </el-col>
        </el-row>
        <el-row>
          <div class="sp_infoTitle title-info"><span></span>
            <p>Other Information</p>
          </div>
          <el-col :span="24">
            <p class="sp_infoCount"><label>Remark:</label><span>{{deviceInfo.remark}}</span></p>
          </el-col>
        </el-row>
        <el-row>
          <div class="sp_infoTitle title-info"><span></span>
            <p>Software Authorized</p>
          </div>
          <el-col :span="24">
            <el-table border
                      :header-cell-style="setHeadeStyle"
                      default-expand-all
                      :show-header="false"
                      row-key="id"
                      :cell-style="cellStyle"
                      :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
                      :data="tableDate">
              <!-- <el-table-column label="#"
                               type="index"
                               align="center"></el-table-column> -->
              <el-table-column label="name"
                               prop="name"
                               show-overflow-tooltip></el-table-column>
              <!-- <el-table-column label="name"
                               prop="name"></el-table-column> -->
              <el-table-column label="Expired Date"
                               prop="value"></el-table-column>
            </el-table>
          </el-col>
        </el-row>
      </div>

      <div class="sp_information"
           v-if="activeIndex == 2">
        <el-row>
          <div class="sp_infoTitle"
               style="height:20px;line-height:20px"><span></span>
            <p style="height:20px;line-height:20px">Upload the Device Files</p>
          </div>
          <div class="upload-lable">
            <p style="color:#2B2B2B;margin-left:20px;width:460px;margin-right:20px;font-size: 14px;">
              <label style="color:#77808c;font-size: 14px;">Last Date of Authorization：</label>
              <span style="color:#333940;font-size: 14px;">{{licenseVO.lastActivationTime?moment(licenseVO.lastActivationTime).format('YYYY-MM-DD'):'-'}}</span>
            </p>
            <p style="color:#2B2B2B;margin-left:20px"><label style="color:#77808c;font-size: 14px;">Status：</label><span style="color:#333940;font-size: 14px;"
                    :style="statusStyle[licenseVO.licStatus]">{{deviceStatus[licenseVO.licStatus]}}</span></p>
          </div>
          <el-col :span="24"
                  style="margin-top:16px;margin-left:20px;margin-right:20px;width:960px">
            <el-upload class="upload-demo"
                       ref="upload"
                       :http-request="uploadSectionFile"
                       :show-file-list="false"
                       :multiple="false"
                       :disabled="disabledUpload"
                       :limit="1"
                       action=""
                       drag>
              <svg-icon style="margin-top:102px;width:24px;height:24px;margin-bottom:24px"
                        v-if="!showProgress&&!uploadSuccess&&!uploadFail"
                        icon-class="uploadFile"></svg-icon>
              <div class="el-upload__text"
                   v-if="!showProgress&&!uploadSuccess&&!uploadFail">Drop files here or click to upload.</div>
              <div class="uploadStatus"
                   v-if="showProgress">
                <p style="color:#2b2b2b;"><label>File Size：</label>{{fileTotal+'KB'}}</p>
                <el-progress :text-inside="false"
                             :stroke-width="8"
                             :percentage="progressPercent"
                             stroke-linecap="square"></el-progress>
              </div>
              <div class="uploadStatus"
                   v-if="uploadSuccess">
                <svg-icon icon-class="succeed"></svg-icon>
                <p style="font-size:20px; font-weight: 600; color: #2B2B2B;">Upload the Device Files success！</p>
                <p style="font-size: 16px; color:#2b2b2b;">{{sfileName}}</p>
                <p style="color:#007AFF; border:1px solid #007AFF; border-radius: 4px; padding:8px 14px; width:104px; font-size:14px; margin:0 auto;">Re-Upload</p>
              </div>
              <div class="uploadStatus"
                   v-if="uploadFail">
                <svg-icon icon-class="fail"></svg-icon>
                <p style="font-size:20px; font-weight: 600; color: #2B2B2B;">Upload Failed</p>
                <p style="font-size: 16px; color:#2b2b2b;">Yuo can Re-Upoad or try to copy and paste to frame below.</p>
                <p style="color:#fff; background:#007AFF; border-radius: 4px; padding:8px 14px; width:104px; font-size:14px; margin:0 auto;">Re-Upload</p>
              </div>
            </el-upload>
          </el-col>

          <el-col :span="24"
                  v-if="uploadFail">
            <el-input type="textarea"
                      textarea
                      :autosize="{ minRows: 6, maxRows: 8}"
                      v-model="fileInfo"></el-input>
          </el-col>

          <el-col :span="24"
                  class="footer">
            <el-button type="primary"
                       size="medium"
                       class="updata"
                       @click="applyLicense"
                       :disabled="fileInfo==''"
                       :loading="activeLoading">{{licenseStatus}}</el-button>
            <el-button plain
                       size="medium"
                       class="download"
                       :disabled="licenseVO.licStatus==0||licenseVO.licStatus==4"
                       @click="handleDownload">
              <svg-icon class="download-icon"
                        icon-class="newdownload"></svg-icon>
              &nbsp;&nbsp;Download License
            </el-button>
          </el-col>

        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import headeTitle from '../../components/headeTitle.vue'
import { tableMixis } from '@/mixins/tableMixis.js'
import { uploadDeviceApi, deviceDetailApi, downloadLicenseApi, applyLicenseApi } from '@/api/assetsList.js'
import moment from 'moment'
export default {
  components: { headeTitle },
  name: "deviceDetails",
  mixins: [tableMixis],
  props: {
    detailsMsg: {
      type: Object,
      required: true,
      default: () => { }
    }
  },
  data () {
    return {
      title: 'Assets Details',
      showClose: true,
      tabsList: [
        { id: 1, name: "Devices Information" },
        { id: 2, name: "License" },
      ],
      activeIndex: 1,
      tableDate: [],
      progressPercent: 10,
      showProgress: false,
      deviceInfo: {},
      licenseVO: {},
      deviceStatus: {
        0: 'Inactivated',
        1: 'Activated',
        2: 'To be Updated',
        4: 'Expired',
      },
      statusStyle: {
        0: {
          color: '#F4A12D',
        },
        1: {
          color: '#32C093',
        },
        2: {
          color: '#007AFF',
        },
        4: {
          color: '#79828C',
        },
      },
      fileTotal: 0,
      uploadSuccess: false,
      uploadFail: false,
      disabledUpload: false,
      fileInfo: '',
      licenseStatus: 'Activate',
      activeLoading: false,
      sfileName: ''
    }
  },
  watch: {
    '$store.state.user.loadAssetePage': {
      handler (val) {
        if (val) {
          this.$emit('detailsChildMsg', false)
        }
      },
      immediate: true
    }
  },

  methods: {
    cellStyle ({ row, column, rowIndex, columnIndex }) {
      if (row.children && row.children.length) {
        return {
          color: '#333940', 'font-weight': '500', 'border-right': 'none !important'
        }
      } else {
        return {
          color: '#545C66', 'font-weight': '400', 'background-color': '#fafbfc',
        }
      }
    },

    handleTabs (data) {
      this.activeIndex = data;
    },

    closePage () {
      this.$emit('detailsChildMsg')
    },

    //获取设备详情
    getDeviceDetail () {
      let params = {
        id: this.detailsMsg.row.id
      }
      deviceDetailApi(params).then(res => {
        this.deviceInfo = res.rows.deviceInfo;
        this.licenseVO = res.rows.licenseVO;
        this.tableDate = res.rows.serviceList
        this.tableDate.forEach((item, index) => {
          item.id = index + 1
        })
      })
    },

    //文件上传
    uploadSectionFile (params) {
      let filetype = params.file.name.split('.')[params.file.name.split('.').length - 1]
      if (filetype.toLowerCase() == 'info') {
        this.disabledUpload = true;//上传时不允许其他操作
        this.progressPercent = 0;
        this.fileTotal = 0;
        const config = {
          onUploadProgress: (progressEvent) => {
            // progressEvent.loaded:已上传文件大小
            // progressEvent.total:被上传文件的总大小
            this.fileTotal = (progressEvent.total / 1024).toFixed(2)
            this.progressPercent = Number(
              ((progressEvent.loaded / progressEvent.total) * 90).toFixed(2)
            );
          },
        };

        this.showProgress = true;
        this.uploadSuccess = false;
        this.uploadFail = false;
        let form = new FormData();
        form.append("file", params.file);
        form.append('id', this.detailsMsg.row.id);
        uploadDeviceApi(form, config).then(res => {
          this.progressPercent = 100
          this.sfileName = params.file.name
          this.$refs.upload.clearFiles();
          setTimeout(() => {
            this.showProgress = false;
            this.uploadSuccess = true;
            this.disabledUpload = false;
            this.fileInfo = res.rows;
          }, 1000);
        }).catch(() => {
          this.$refs.upload.clearFiles();
          this.showProgress = false;
          this.disabledUpload = false;
          this.uploadFail = true;
          this.fileInfo = '';
        })
      } else {
        this.$refs.upload.clearFiles();
        this.$message({
          type: "warning",
          message: 'Only info files can be uploaded.'
        })
      }
    },

    //文件下载
    handleDownload () {
      let params = { id: this.detailsMsg.row.id }
      downloadLicenseApi(params).then(res => {
        let fileName = res.headers['content-disposition'].split(';')[1].split('=')[1]
        const a = document.createElement('a')
        const blob = new Blob([res.data])
        const objectUrl = URL.createObjectURL(blob)
        a.setAttribute('href', objectUrl)
        a.setAttribute('download', fileName)
        a.click()
        URL.revokeObjectURL(objectUrl)
      })
    },

    //激活设备
    applyLicense () {
      this.activeLoading = true;
      let params = {
        id: this.detailsMsg.row.id,
        devInfo: this.fileInfo,
      }
      applyLicenseApi(params).then(res => {
        this.activeLoading = false;
        if (res.code == 0) {
          this.getDeviceDetail()
          this.$message({
            type: 'success',
            message: this.detailsMsg.row.licStatus == 0 ? "Activated Successfully" : 'Updated Successfully'
          })
          this.$emit('detailsChildMsg')
          this.licenseStatus = 'Update'
        } else if (res.code == 500) {
          this.$message({
            type: 'success',
            message: this.detailsMsg.row.licStatus == 0 ? "Activated Failed" : 'Updated failed'
          })
        }
      }).catch(() => {
        this.activeLoading = false;
      })
    }
  },

  created () {
    console.log(this.detailsMsg);
    this.getDeviceDetail()
    if (this.detailsMsg.toLicense) {
      this.activeIndex = 2;
    }
    this.licenseStatus = this.detailsMsg.row.licStatus == 0 ? "Activate" : "Update"
  },

  computed: {
    moment () {
      return moment
    }
  }
}
</script>

<style scoped lang="scss">
.sp_deviceDetails {
  width: 100% !important;
  height: 100% !important;
  background: #fff !important;
  .tab-content {
    cursor: pointer;
    display: flex;
    justify-content: flex-start;
    margin-right: 6px;
    background-color: #f0f3f7;
    .tab {
      background-color: #f5f7fa;
      height: 36px;
      line-height: 36px;
      padding: 0 16px;
      margin-right: 6px;
    }
    .is_active {
      color: #2684ff;
      border-top: 2px solid #2684ff;
      background-color: #ffffff;
    }
  }
  .tab:hover {
    color: #2684ff;
  }
  .sp_content {
    width: 100%;
    background: #fff;
    padding: 32px 16px 0;
    margin-bottom: 16px;
    // min-height: calc(100% - 53px);
    .sp_information {
      width: 100%;
      /deep/.el-col-8 {
        margin-bottom: 24px;
      }
      .sp_infoTitle {
        width: 100%;
        display: flex;
        align-items: center;
        height: 20px;
        line-height: 20px;
        margin-bottom: 20px;
        font-size: 14px;
        span {
          width: 4px;
          height: 16px;
          background: #007aff;
          margin: 0 8px;
        }
        p {
          font-weight: 600;
          font-size: 16px;
        }
      }
      .title-info {
        margin-top: 24px;
      }
      .upload-lable {
        height: 20px;
        line-height: 20px;
        display: flex;
        justify-content: flex-start;
      }
      .footer {
        padding: 13px;
        border-top: 1px solid #e9edf2;
        .el-button {
          height: 36px;
          margin-right: 8px;
          margin-left: 0;
        }
      }
      .sp_infoCount {
        margin-left: 20px;
        label {
          color: #a1a8b3;
          font-size: 14px;
          height: 20px;
          line-height: 20px;
        }
        span {
          width: 100%;
          display: inline-block;
          font-size: 14px;
          height: 20px;
          line-height: 20px;
          color: #2b2b2b;
          margin-top: 4px;
        }
      }
      .upload-demo {
        height: 316px;
        width: 100%;
        /deep/.el-upload {
          width: 100%;
          height: 220px;
          .el-upload-dragger {
            width: 100%;
            height: 210px;
          }
        }
        /deep/.el-upload-dragger {
          height: 300px !important;
        }
        .uploadStatus {
          width: 42%;
          margin: 0px auto;
          top: 50%;
          position: absolute;
          left: 50%;
          transform: translate(-50%, -50%);
          .svg-icon {
            width: 24px !important;
            height: 24px !important;
            font-size: 48px;
            margin-bottom: 10px;
          }
          p {
            margin-bottom: 10px;
          }
        }
        .el-upload__text {
          color: #333940;
          height: 22px;
          font-size: 16px;
          line-height: 22px;
        }
      }
    }
  }
}
.download {
  border: 1px solid #d3d9e0;
  color: #333940;
  span {
    display: flex;
    align-items: center;
  }
}
.download:hover {
  .download-icon {
    color: #007aff !important;
  }
}
</style>